import type { FC } from 'react';
import React from 'react';

import type { IconButtonProps } from '@mui/material';
import { Box, Collapse, IconButton, styled } from '@mui/material';

import { DividerComp } from 'components/_legacy/DividerComp';
import ChevronDownIcon from 'components/icons/ChevronDown';
import type {
  EventHistoryInfo,
  NodeInfo
} from 'pages/projects/projectPage/selectedProject/projectHistory/EventHistory.types';
import { EventHistoryCard } from 'pages/projects/projectPage/selectedProject/projectHistory/EventHistoryCard';

interface ExpandMoreProps extends IconButtonProps {
  expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  marginTop: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest
  })
}));

interface EventHistoryProps {
  date: string;
  eventsHistoryInfo: EventHistoryInfo[];
  targetNode: NodeInfo;
}

export const EventHistory: FC<EventHistoryProps> = ({ date, eventsHistoryInfo, targetNode }) => {
  const [expanded, setExpanded] = React.useState(true);
  const handleExpandClick = () => setExpanded(!expanded);

  return (
    <div>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <DividerComp title={date} sx={{ flexGrow: 1 }} />

        <ExpandMore expand={expanded} onClick={handleExpandClick}>
          <ChevronDownIcon fontSize='small' sx={(theme) => ({ color: theme.palette.grey['A700'] })} />
        </ExpandMore>
      </Box>

      <Collapse in={expanded} timeout='auto' unmountOnExit>
        {eventsHistoryInfo.map((eventHistoryInfo, index) => {
          return (
            <EventHistoryCard
              key={`event-history-card-${eventHistoryInfo.transactionId}+${eventHistoryInfo.timeStamp}+${index}`}
              targetNode={targetNode}
              eventHistoryInfo={eventHistoryInfo}
            />
          );
        })}
      </Collapse>
    </div>
  );
};
